/*
 * Public API Surface of ngx-sse-client
 */
export * from './lib/sse-client.service';
export * from './lib/sse-error-event.interface';
export * from './lib/sse-options.interface';
export * from './lib/sse-request-options.interface';
